// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

/* 饿了么 */
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

/* 全局基础样式 、全局字体图标 */
import './assets/css/global.css'
import './assets/iconfonts/iconfont.css'
import './assets/iconfonts/iconfont.js'

/* 主题颜色 */
import './assets/css/mixin.scss'
/* 备课样式 */
import './assets/css/ready-course/style.scss'
/* 授课样式 */
import './assets/css/give-course/style.scss'

/* vue-echarts */
import ECharts from 'vue-echarts'

/* 滑动验证码 */
import SlideVerify from 'vue-monoplasty-slide-verify'

// 图片预览
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

import 'echarts-liquidfill'
Vue.use(Viewer);
Viewer.setDefaults({
  Options: { zIndex:999999,"inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});

import moment from 'moment/moment'
Vue.filter('moment', function (value, formatString) {
  formatString = formatString || 'YYYY-MM-DD';
  return moment(value).format(formatString);
});

/* 删除提示 */
Vue.prototype.delMsg = function (res, msg = "此操作将永久删除该数据, 确定要删除吗?") {
  this.$confirm(msg, "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      res()
    })
    .catch(() => {
      // this.$message({
      //   type: "info",
      //   message: "已取消删除",
      // });
    });
}
Vue.component('v-chart', ECharts)


Vue.config.productionTip = false

/* eslint-disable no-new */
Vue.use(ElementUI)
Vue.use(SlideVerify)
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js